<div class="button-menu">
  @if (!copyInsteadOfShare) {
    <a [href]="emailHref" target="_blank" (click)="onClose.emit()">
      <app-button-menu-item name="{{ name | lowercase }}-email" location="share-menu" icon="email" [fullWidth]="true">
        Send Email
      </app-button-menu-item>
    </a>
  }
  @if (copyInsteadOfShare) {
    <app-button-menu-item
      name="{{ name | lowercase }}-copy"
      location="share-menu"
      icon="link"
      [fullWidth]="true"
      [copy-clipboard]="link"
      (onClick)="onCopy()"
    >
      Copy Link
    </app-button-menu-item>
  }
  <div class="divider"></div>
  <a [href]="facebookHref" target="_blank" (click)="onClose.emit()">
    <app-button-menu-item
      name="{{ name | lowercase }}-facebook"
      location="share-menu"
      icon="logo/facebook"
      [fullWidth]="true"
    >
      Facebook
    </app-button-menu-item>
  </a>
  <a [href]="whatsappHref" target="_blank" (click)="onClose.emit()">
    <app-button-menu-item
      name="{{ name | lowercase }}-whatsapp"
      location="share-menu"
      icon="logo/whatsapp"
      [fullWidth]="true"
    >
      Whatsapp
    </app-button-menu-item>
  </a>
  <a [href]="twitterHref" target="_blank" (click)="onClose.emit()">
    <app-button-menu-item
      name="{{ name | lowercase }}-twitter"
      location="share-menu"
      icon="logo/twitter"
      [fullWidth]="true"
    >
      Twitter
    </app-button-menu-item>
  </a>
  <a [href]="linkedinHref" target="_blank" (click)="onClose.emit()">
    <app-button-menu-item
      name="{{ name | lowercase }}-linkedin"
      location="share-menu"
      icon="logo/linkedin"
      [fullWidth]="true"
    >
      LinkedIn
    </app-button-menu-item>
  </a>
</div>
